__turbopack_context__.v({
  "caret": "MusicPlayer-module-scss-module__SxeVNG__caret",
  "dot": "MusicPlayer-module-scss-module__SxeVNG__dot",
  "dotLive": "MusicPlayer-module-scss-module__SxeVNG__dotLive",
  "inHero": "MusicPlayer-module-scss-module__SxeVNG__inHero",
  "inNav": "MusicPlayer-module-scss-module__SxeVNG__inNav",
  "item": "MusicPlayer-module-scss-module__SxeVNG__item",
  "itemOn": "MusicPlayer-module-scss-module__SxeVNG__itemOn",
  "list": "MusicPlayer-module-scss-module__SxeVNG__list",
  "listBtn": "MusicPlayer-module-scss-module__SxeVNG__listBtn",
  "pill": "MusicPlayer-module-scss-module__SxeVNG__pill",
  "play": "MusicPlayer-module-scss-module__SxeVNG__play",
  "pulse": "MusicPlayer-module-scss-module__SxeVNG__pulse",
  "root": "MusicPlayer-module-scss-module__SxeVNG__root",
  "soon": "MusicPlayer-module-scss-module__SxeVNG__soon",
  "spin": "MusicPlayer-module-scss-module__SxeVNG__spin",
  "spinner": "MusicPlayer-module-scss-module__SxeVNG__spinner",
  "title": "MusicPlayer-module-scss-module__SxeVNG__title",
  "titleStatic": "MusicPlayer-module-scss-module__SxeVNG__titleStatic",
});
